export const supportsShadowDOM = () => {
  return document.head.attachShadow;
};
